import { gql } from "@apollo/client";

export const GET_EMAIL_INCOMINGS = gql`
  query GetEmailIncomings(
    $first: Int!
    $page: Int
    $where: QueryEmailIncomingsWhereWhereConditions
    $orderBy: [QueryEmailIncomingsOrderByOrderByClause!]
  ) {
    emailIncomings(first: $first, page: $page, where: $where, orderBy: $orderBy) {
      paginatorInfo {
        total
        count
        currentPage
        perPage
        lastPage
      }
      data {
        id
        email_channel_id
        message_id
        message_uid
        subject
        from_email
        from_name
        header_meta {
          cc
          to
          from
          sent_at
          subject
          priority
        }
        body_clean
        intent
        status
        parse_error
        parsed_data
        used_token
        received_at
        parsed_at
        created_at
        updated_at
        relEmailChannel {
          id
          title
        }
        relEmailRequests {
          id
          email_incoming_id
          ee_id
          stand_id
          equipment_id
          flooring_id
          exhibition_name
          company_name
          stand_number
          action
          item_name
          item_qty
          item_notes
          confidence
          status
          ai_data
          processed_by_id
          processed_at
          notes
          created_at
          updated_at
          relExhibitionEvent {
            id
            title
            organizer_id
            exhibition_type_id
            organizer {
              id
              title
            }
            exhibitionType {
              id
              title
            }
          }
          relStand {
            id
            stand_number
            company_name
          }
          relEquipment {
            id
            group_id
            title
            color
          }
          relFlooring {
            id
            title
            color
          }
        }
      }
    }
  }
`;

export const GET_EMAIL_REQUESTS = gql`
  query GetEmailRequests(
    $first: Int!
    $page: Int
    $where: QueryEmailRequestsWhereWhereConditions
    $orderBy: [QueryEmailRequestsOrderByOrderByClause!]
  ) {
    emailRequests(first: $first, page: $page, where: $where, orderBy: $orderBy) {
      paginatorInfo {
        total
        count
        currentPage
        perPage
        lastPage
      }
      data {
        id
        email_incoming_id
      }
    }
  }
`;
